import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "./authReducer";

import AppLayout from '../components/AppLayout';

const RequireAuth = () => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();
  return (
    token && token.access_token ? 
      <AppLayout>
        <Outlet />
      </AppLayout> : <Navigate to="/" state={{ from: location }} replace />
  )
}
export default RequireAuth
